import { InputAdornment, TextField } from '@mui/material';
import { ChangeEvent, FC } from 'react';

interface IChanceCellProps {
  scenarioId: number;
  value: number | null;
  onChange: (scenarioId: number, weight: number | null) => void;
  disabled?: boolean;
}

/** Editable per-scenario `% Chance` input (0–100); auto-saves via the parent's debounced handler. */
export const ChanceCell: FC<IChanceCellProps> = ({ scenarioId, value, onChange, disabled }) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    if (raw === '') {
      onChange(scenarioId, null);
      return;
    }
    const parsed = Number(raw);
    if (Number.isNaN(parsed)) {
      return;
    }
    onChange(scenarioId, Math.min(100, Math.max(0, parsed)));
  };

  return (
    <TextField
      type='number'
      size='small'
      value={value ?? ''}
      onChange={handleChange}
      disabled={disabled}
      placeholder='—'
      inputProps={{ min: 0, max: 100, step: 1, 'aria-label': 'percent chance' }}
      InputProps={{ endAdornment: <InputAdornment position='end'>%</InputAdornment> }}
      sx={{
        width: '5.5rem',
        margin: 0,
        // Hide native number steppers to match the design's clean "40%" field.
        '& input[type=number]': { MozAppearance: 'textfield' },
        '& input[type=number]::-webkit-outer-spin-button': { WebkitAppearance: 'none', margin: 0 },
        '& input[type=number]::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 },
      }}
    />
  );
};
